module.exports = __webpack_public_path__ + "img/linkdin.48618a4b.svg";